export enum AuthSessionPolicy {
    ReLogin = 'relogin',
    FullLogout = 'full_logout',
}
